export const FURNITURE_URL = `${process.env.REACT_APP_BACK_SHEET}/furnitures`

export const FURNITURES_GET_ALL = {
  url: FURNITURE_URL,
  method: 'GET',
}
